var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 28,
    viewBox: "0 0 26 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 7.75C13.5178 7.75 13.9375 8.16973 13.9375 8.6875V15.25C13.9375 15.7678 13.5178 16.1875 13 16.1875C12.4822 16.1875 12.0625 15.7678 12.0625 15.25V8.6875C12.0625 8.16973 12.4822 7.75 13 7.75Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4949 2.83801C13.557 2.30283 12.4134 2.30554 11.493 2.83691L4.07138 7.12243C3.14397 7.66873 2.57422 8.6621 2.57422 9.72504V18.275C2.57422 19.3545 3.1472 20.3441 4.06796 20.8756L11.4894 25.1611C11.49 25.1614 11.4906 25.1617 11.4911 25.1621C12.4291 25.6972 13.5726 25.6945 14.493 25.1632C14.493 25.1632 14.4929 25.1632 14.493 25.1632L21.9118 20.8793C21.9128 20.8787 21.9137 20.8781 21.9147 20.8776C22.8421 20.3312 23.4118 19.3379 23.4118 18.275V9.72504C23.4118 8.65125 22.8435 7.66954 21.9146 7.12242C21.9137 7.12187 21.9127 7.12132 21.9118 7.12077L14.4966 2.83898C14.4961 2.83865 14.4955 2.83833 14.4949 2.83801ZM10.5555 1.21309C12.0595 0.344785 13.9152 0.347178 15.4269 1.21102L15.4306 1.21312L22.8617 5.50419C24.3562 6.3824 25.2868 7.97492 25.2868 9.72504V18.275C25.2868 20.011 24.3577 21.6168 22.8617 22.4958L22.8556 22.4994L15.4306 26.7869C13.9265 27.6552 12.0708 27.6529 10.5591 26.789L10.5554 26.7869L3.1305 22.4995C1.62626 21.631 0.699219 20.0205 0.699219 18.275V9.72504C0.699219 7.98906 1.62834 6.38326 3.12426 5.50421L3.13041 5.5006L10.5555 1.21309Z",
    fill: "#292D32"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 18C13.6904 18 14.25 18.5596 14.25 19.25V19.375C14.25 20.0654 13.6904 20.625 13 20.625C12.3096 20.625 11.75 20.0654 11.75 19.375V19.25C11.75 18.5596 12.3096 18 13 18Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.424a4008dc79994799fec75c88ca6885.svg";
export { ForwardRef as ReactComponent };